import { createDarkTheme, createLightTheme, type Theme } from '@fluentui/react-components';

import { caredocsBrand } from './caredocsBrand';

const baseDark = createDarkTheme(caredocsBrand);
const baseLight = createLightTheme(caredocsBrand);

/** Surface tweaks: slightly cooler dark surfaces for clinical-app readability. */
export const caredocsDarkTheme: Theme = {
  ...baseDark,
  colorNeutralBackground1: '#0c121b',
  colorNeutralBackground2: '#10182a',
  colorNeutralBackground3: '#152035',
  colorBrandBackground: caredocsBrand[80],
  colorBrandForeground1: caredocsBrand[110],
  colorBrandForeground2: caredocsBrand[120],
};

export const caredocsLightTheme: Theme = {
  ...baseLight,
};

export type CaredocsThemeName = 'dark' | 'light';

export function resolveTheme(name: CaredocsThemeName): Theme {
  return name === 'dark' ? caredocsDarkTheme : caredocsLightTheme;
}
